export const languageConstanst = {
  CHANGE_LANGUAGE: 'CHANGE_LANGUAGE',
};
